import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  API_SERVICE_CONFIG,
  IApiServiceConfig,
} from '../base/configuration/api-service-config';
import { Location, LocationInput, MiniLocation } from './location';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ApiLocationsAdapterService {
  private readonly baseUrl = 'locations';

  constructor(
    private http: HttpClient,
    @Inject(API_SERVICE_CONFIG) private config: IApiServiceConfig,
  ) {}

  getMini(): Observable<MiniLocation[]> {
    return this.http.get<MiniLocation[]>(
      `${this.config.url}${this.baseUrl}/names`,
    );
  }

  getAllByCompany(companyId: string): Observable<Location[]> {
    const params = new HttpParams().set('companyId', companyId);
    return this.http.get<Location[]>(`${this.config.url}${this.baseUrl}`, {
      params,
    });
  }

  getById(id: string): Observable<Location> {
    return this.http.get<Location>(`${this.config.url}${this.baseUrl}/${id}`);
  }

  create(location: LocationInput): Observable<Location> {
    return this.http.post<Location>(
      `${this.config.url}${this.baseUrl}`,
      location,
    );
  }

  update(id: string, location: LocationInput): Observable<Location> {
    return this.http.patch<Location>(
      `${this.config.url}${this.baseUrl}/${id}`,
      location,
    );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.config.url}${this.baseUrl}/${id}`);
  }
}
